'use strict';

function getUniqueArrayFromObjects(values = [], select) {
  const result = values.reduce((array, item) => {
    array.indexOf(select(item)) < 0 && array.push(select(item));
    return array;
  }, []);

  return result;
}

module.exports = getUniqueArrayFromObjects;
